module.exports = __webpack_public_path__ + "static/media/goggles.280019f8.png";